import { adminAxiosInstance } from "./adminAxiosInstance";

const OVERVIEW_CACHE_TTL = 2 * 60 * 1000;
const overviewCache = new Map();
const overviewRequests = new Map();
const number = (value) => Number(value || 0);

const normalizeOverviewStats = (response, requestedDays) => ({
  status: response?.status !== false,
  message: response?.message,
  period_days: response?.period_days ?? requestedDays,
  start_date: response?.start_date || null,
  end_date: response?.end_date || null,
  order_metrics: {
    total_orders: number(response?.order_metrics?.total_orders),
    successful_orders: number(response?.order_metrics?.successful_orders),
    cancelled_orders: number(response?.order_metrics?.cancelled_orders),
    recovered_orders: number(response?.order_metrics?.recovered_orders),
    delivered_orders: number(response?.order_metrics?.delivered_orders),
    fulfillment_rate_percentage: number(response?.order_metrics?.fulfillment_rate_percentage),
  },
  financial_metrics: {
    gross_merchandise_value_ngn: number(response?.financial_metrics?.gross_merchandise_value_ngn),
    total_delivery_fees_collected_ngn: number(response?.financial_metrics?.total_delivery_fees_collected_ngn),
  },
  logistics_metrics: {
    distance_covered_km: number(response?.logistics_metrics?.distance_covered_km),
    metric_tonnes_moved: number(response?.logistics_metrics?.metric_tonnes_moved),
    metric_kg_moved: number(response?.logistics_metrics?.metric_kg_moved),
  },
  summary: {
    total_ratings: number(response?.summary?.total_ratings),
    average_overall_rating: number(response?.summary?.average_overall_rating),
    average_freshness_rating: number(response?.summary?.average_freshness_rating),
    average_timeliness_rating: number(response?.summary?.average_timeliness_rating),
    average_packaging_rating: number(response?.summary?.average_packaging_rating),
    rating_distribution: response?.summary?.rating_distribution || {},
  },
});

export const getAdminOverviewStats = (days = 30) => {
  const normalizedDays = days === "allTime" ? "allTime" : Number(days) || 30;
  const cached = overviewCache.get(normalizedDays);
  if (cached && Date.now() - cached.updatedAt < OVERVIEW_CACHE_TTL) return Promise.resolve(cached.data);
  if (overviewRequests.has(normalizedDays)) return overviewRequests.get(normalizedDays);

  const request = adminAxiosInstance
    .get("/admin/internal/ops/overview/stats", { params: { days: normalizedDays } })
    .then(({ data }) => {
      const result = normalizeOverviewStats(data, normalizedDays);
      if (!result.status) throw new Error(result.message || "Overview statistics could not be loaded.");
      overviewCache.set(normalizedDays, { data: result, updatedAt: Date.now() });
      return result;
    })
    .finally(() => overviewRequests.delete(normalizedDays));

  overviewRequests.set(normalizedDays, request);
  return request;
};

export const clearAdminOverviewStatsCache = () => {
  overviewCache.clear();
  overviewRequests.clear();
};
